import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Bridge } from '@frontend/containers/Bridge';
import React from 'react';

var BridgePage = function BridgePage() {
  return _jsx(Bridge, {});
};

export var __N_SSG = true;
export default BridgePage;